import { Button } from '@mantine/core';
import { HiArrowUpRight } from 'react-icons/hi2';
import IntegrationCardBase from '@/pages/Integrations/components/IntegrationCardBase.tsx';
import useCreateNangoIntegration from '@/hooks/useCreateNangoIntegration.ts';
import { IntegrationProvider } from '@/types/integrations.ts';
import { useState } from 'react';
import SharePointConnectModal from '@/components/SharePointConnectModal.tsx';
import { isSharePointProvider } from '@/utils/providerKinds.ts';

type props = {
  provider?: IntegrationProvider;
  setSelectedIntegration: (provider?: IntegrationProvider) => void;
};

const IntegrationProviderCard = ({ provider, setSelectedIntegration }: props) => {
  const { createIntegration, createIntegrationFromButton, creatingIntegration } =
    useCreateNangoIntegration();
  const [sharePointConnectOpened, setSharePointConnectOpened] = useState(false);

  if (!provider) {
    return null;
  }

  const action = (
    <Button
      size={'xs'}
      rightSection={
        <HiArrowUpRight size={10} color={'white'} strokeWidth={1.2} style={{ marginTop: '-4px' }} />
      }
      styles={{
        section: {
          marginLeft: 5, // Reduce space between text and icon
        },
        label: {
          fontWeight: 500,
        },
      }}
      onClick={async (e) => {
        e.stopPropagation();
        if (isSharePointProvider(provider)) {
          setSharePointConnectOpened(true);
          return;
        }
        await createIntegrationFromButton(provider);
      }}
      loading={creatingIntegration}
    >
      Enable
    </Button>
  );

  return (
    <>
      <IntegrationCardBase
        action={action}
        provider={provider}
        setSelectedIntegration={setSelectedIntegration}
        showInfoIcon={true}
      />
      {isSharePointProvider(provider) && (
        <SharePointConnectModal
          opened={sharePointConnectOpened}
          onClose={() => setSharePointConnectOpened(false)}
          confirmLoading={creatingIntegration}
          onConfirm={async (sharepointTenantId) => {
            await createIntegration(provider, sharepointTenantId);
            setSharePointConnectOpened(false);
          }}
        />
      )}
    </>
  );
};

export default IntegrationProviderCard;
